import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App.vue'
import router from './router'
import store from './store'
import config from './config/index'
import '@/assets/css/tailwindcss.css'
import './global.jsx'

store.dispatch('system/setConfig', config)
// router.addRoutes(routes)
Vue.use(VueI18n)
// 准备翻译的语言环境信息
const messages = {
  en: {
    message: {
      hello: 'hello world',
    },
  },
  ja: {
    message: {
      hello: 'こんにちは、世界',
    },
  },
}
// 通过选项创建 VueI18n 实例
const i18n = new VueI18n({
  locale: 'ja', // 设置地区
  messages, // 设置地区信息
})
const vueOptions = {
  el: 'body',
  store,
  render: h => h(App),
}

new Vue({
  ...vueOptions,
  router,
  el: '#app',
  i18n,
})
